import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/travel.jpg";
import emotion from "../../Assets/Projects/mern-eats.jpg";
import editor from "../../Assets/Projects/calculator.png";
import chatify from "../../Assets/Projects/emazon.jpg";
import suicide from "../../Assets/Projects/ai.jpg";
import bitsOfCode from "../../Assets/Projects/ecommerce-store.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={4} className="project-card"  >
            <ProjectCard 
              imgPath={bitsOfCode}
              isBlog={false}
              title ="Ecommerce-Store"

              description="New IT technologies have completely changed the way people shop in the 21st century. Internet and mobile 
                    devices have made it possible to purchase products or services at any time and in any location. As a result, a 
                    tremendous number of e-commerce websites appeared on the world wide web. However, it's very easy, fast, more 
                    comfortable & time-saving process."

              ghLink="https://github.com/ZIAN786/ecommerce-store"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Companion Ai"
          
              description="Artificial intelligence is the simulation of human intelligence processes by machines, especially computer 
              systems. AI requires a foundation of specialized hardware and software for writing and training machine learning 
              algorithms. In general, AI systems work by ingesting large amounts of labeled training data, analyzing the data for 
              using these patterns to make predictions about future states. "

              ghLink="https://github.com/ZIAN786/ai-companion"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Mern-Eats"

              description="The Food Ordering App lets users browse menus, filter by cuisine, view dish details, and customize meals from various restaurants. With secure payments, real-time tracking, and delivery estimates, it offers a seamless experience, saving favorites, reordering past meals, and delivering food quickly while enhancing customer and restaurant satisfaction."

              ghLink="https://github.com/ZIAN786/mern-food-ordering-app-frontend"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Ema-John"
              description="Ema-John is an online retailer and web service provider. The company provides products such as apparel, auto 
              and industrial items, beauty and health products, electronics, grocery, games, jewelry, kids and baby products, music, 
              sports goods, toys, and tools. It also offers related support services including home delivery and shipping, cloud web 
              hosting and other web related services. Amazon merchandises its products through company-owned online and physical 
              platforms."
               

              ghLink="https://github.com/ZIAN786/ema-john-simple-2"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="React-Calculator"
              description="This is a simple basic calculator with memory functions similar to a small handheld calculator. Use this 
              basic calculator online for math with addition,subtraction,division and multiplication. Memory and clear functions for 
              this standard calculator are listed below.

mc = Memory Clear
m+ = Memory Plus
m- = Memory Minus
mr = Memory Recall
CE = Clear Entry
AC = All Clear
etc.
It allow more students to solve problems and appreciate the power and value of mathematics in the world today."
              ghLink="https://github.com/ZIAN786/react-calculator"
                           
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Traveling Website"
              description="Easy Tips to Reduce Plastic & Travel Plastic-Free
              HOME
              TIPS.
              It is easy to feel hopeless in the current war against climate change, and specifically the battle against single-use 
              plastic. We are all guilty of using plastic in our day to day lives, but reducing plastic is not as hard as it seems. We 
              hear you thinking, ‘how can one person like me make a difference?’. You can and will easily make a difference by using the 
              following tips to travel plastic-free & enjoy your wonderful life."
              ghLink="https://github.com/ZIAN786/travel-website"
              
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
